import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ApplicationDetail = ({application, showModal, handleShowModal, handleCloseModal}) => {
  return (
    <div>
      <Button variant="primary" onClick={handleShowModal}>
        Open Modal
      </Button>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header>
          <Modal.Title>{application?.application_no}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{application?.owner}</p>
          <p>{application?.order_payment_no}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ApplicationDetail;
